import type { ComparisonConfig } from './ComparisonPage';

const OPERA_DE: ComparisonConfig = {
  slug: 'hotelstack-vs-opera',
  competitorName: 'Oracle OPERA',
  heroTitle: 'HotelStack.io vs Oracle OPERA',
  heroSubtitle: 'Oracle OPERA ist der traditionelle Branchenstandard — vor Jahrzehnten entwickelt und immer noch mit Enterprise-Komplexitaet und -Preisen belastet. HotelStack.io bietet eine moderne, Cloud-native Alternative mit mehr Modulen, einfacherer Preisgestaltung und null Infrastruktur-Overhead.',
  overviewComparison: [
    { label: 'Architektur', hotelstack: 'Cloud-natives SaaS', competitor: 'Legacy On-Premise / Cloud' },
    { label: 'Preise', hotelstack: 'Ab $49/Monat', competitor: '$500+/Monat + Lizenzen' },
    { label: 'Implementierung', hotelstack: 'Kostenlos — 48h Onboarding', competitor: '3-6 Monate Implementierung' },
    { label: 'Module gesamt', hotelstack: '36 integriert', competitor: '20+ (Separate Lizenzen)' },
    { label: 'F&B / POS', hotelstack: 'Integriert', competitor: 'Separate OPERA POS-Lizenz' },
    { label: 'Zielsegment', hotelstack: 'KMU bis Enterprise', competitor: 'Nur Enterprise' },
  ],
  featureTable: [
    {
      category: 'Kern-PMS',
      features: [
        { name: 'Reservierungsverwaltung', hotelstack: true, competitor: true },
        { name: 'Visuelle Zimmertafel', hotelstack: true, competitor: true },
        { name: 'Nachtabschluss-Assistent', hotelstack: true, competitor: true },
        { name: 'Gastefolio-Verwaltung', hotelstack: true, competitor: true },
        { name: 'Gruppenbuchungen', hotelstack: true, competitor: true },
        { name: 'Online Check-In Portal', hotelstack: true, competitor: 'Zusatzmodul' },
      ],
    },
    {
      category: 'Cloud & Zugaenglichkeit',
      features: [
        { name: 'Echte Cloud-native Loesung', hotelstack: true, competitor: 'Hybrid' },
        { name: 'Keine Serverwartung', hotelstack: true, competitor: false },
        { name: 'Echtzeit-Multi-Geraete-Sync', hotelstack: true, competitor: 'Eingeschraenkt' },
        { name: 'Moderne Responsive-Oberflaeche', hotelstack: true, competitor: false },
        { name: 'Automatische Updates', hotelstack: true, competitor: false },
        { name: 'Kein IT-Personal erforderlich', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Ertragsmanagement',
      features: [
        { name: 'Dynamische Preisregeln', hotelstack: true, competitor: true },
        { name: 'Was-Waere-Wenn-Ertragssimulator', hotelstack: true, competitor: false },
        { name: 'Wettbewerbspreise-Monitor', hotelstack: true, competitor: 'Ueber Oracle BI' },
        { name: 'Nachfrageprognose', hotelstack: true, competitor: true },
        { name: 'RevPAR-Analysen', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'F&B & Betrieb',
      features: [
        { name: 'POS-Terminal', hotelstack: true, competitor: 'Separate Lizenz' },
        { name: 'Zimmerservice-Modul', hotelstack: true, competitor: 'Separate Lizenz' },
        { name: 'Kuechenanzeigesystem', hotelstack: true, competitor: false },
        { name: 'Personalplanung', hotelstack: true, competitor: false },
        { name: 'Wartungsauftraege', hotelstack: true, competitor: 'Ueber Integration' },
      ],
    },
    {
      category: 'Kosten & Onboarding',
      features: [
        { name: 'Kostenloses Onboarding', hotelstack: true, competitor: false },
        { name: 'Kostenlose Datenmigration', hotelstack: true, competitor: false },
        { name: 'Keine Serverkosten', hotelstack: true, competitor: false },
        { name: 'Keine Lizenzgebuehren', hotelstack: true, competitor: false },
        { name: 'Regionale Waehrungspreise', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Resilienz & Offline',
      features: [
        { name: 'Offlinefaehige PWA', hotelstack: true, competitor: false },
        { name: 'Offline-Warteschlange fuer Aenderungen', hotelstack: true, competitor: false },
        { name: 'Hintergrundsynchronisierung bei Wiederverbindung', hotelstack: true, competitor: false },
        { name: 'Konfliktbewusster Abgleich', hotelstack: true, competitor: false },
        { name: 'Installierbare Rezeption', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Firmenkunden & Gruppenverkauf',
      features: [
        { name: 'Firmenratenverwaltung', hotelstack: true, competitor: 'Zusatzmodul' },
        { name: 'Gruppenbuchung mit Zimmerlisten', hotelstack: true, competitor: 'Zusatzmodul' },
        { name: 'Offene-Posten- & Produktionsberichte', hotelstack: true, competitor: 'Zusatzmodul' },
        { name: 'Restaurantreservierungen', hotelstack: true, competitor: 'Micros-Zusatzmodul' },
      ],
    },
    {
      category: 'Personal & HR',
      features: [
        { name: 'Mitarbeiterverzeichnis & Dienstplanung', hotelstack: true, competitor: 'Ueber Integration' },
        { name: 'Lohnabrechnung', hotelstack: true, competitor: false },
        { name: 'Urlaub & Anwesenheit', hotelstack: true, competitor: false },
        { name: 'Leistungsanalysen', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$500+',
    hotelstackNote: 'Alle 36 Module enthalten. Keine Lizenzgebuehren. Keine Serverkosten. Kostenloses Onboarding und Migration. Regionale Preise in EUR, GBP, AED, INR, THB.',
    competitorNote: 'Enterprise-Lizenzierung ab $500+/Monat pro Objekt. Separate POS-, S&C- und OCRM-Lizenzen. Implementierungskosten ab $50.000+. On-Premise-Server fuer Classic Edition erforderlich.',
  },
  advantages: [
    'Ueber 90% niedrigere Gesamtbetriebskosten — keine Lizenzgebuehren, Serverkosten oder Implementierungsgebuehren',
    'Inbetriebnahme in 48 Stunden vs. 3-6 Monate OPERA-Implementierungszeitraum',
    'Moderne Cloud-native Oberflaeche von jedem Geraet zugaenglich — kein Desktop-Client erforderlich',
    'Alle 36 Module in einem Abonnement enthalten vs. separate OPERA-Modullizenzen',
    'Keine IT-Infrastruktur — keine Server, keine Patches, kein Oracle DBA erforderlich',
    'Integriertes F&B und POS ohne Zusatzkosten vs. separate OPERA POS-Lizenzierung',
    'Regionale Preise in 6 Waehrungen, damit Hotels in Landeswaehrung zahlen',
    'Kostenlose Datenmigration von OPERA mit dediziertem Support-Team',
  ],
  verdict: {
    title: 'Unser Fazit',
    summary: 'Oracle OPERA ist seit Jahrzehnten der Branchenstandard und bleibt eine solide Wahl fuer grosse Enterprise-Ketten mit bestehender Oracle-Infrastruktur. Fuer die ueberwiegende Mehrheit der Hotels bietet HotelStack.io jedoch mehr Module, bessere UX und dramatisch niedrigere Kosten ohne die monatelangen Implementierungszyklen, den Server-Overhead und die komplexe Lizenzierung, die OPERA erfordert.',
    bestFor: [
      'Hotels, die teure Oracle-Lizenz- und Infrastrukturkosten eliminieren moechten',
      'Objekte, die von langsamen OPERA-Implementierungs- und Upgrade-Zyklen frustriert sind',
      'Hotels, die eine moderne Cloud-native Oberflaeche ohne Desktop-Client-Abhaengigkeit benoetigen',
      'KMU- und Mittelklasse-Hotels, fuer die OPERA-Enterprise-Plaene zu teuer sind',
      'Objekte, die alle Module ohne separate Lizenzgebuehren wuenschen',
    ],
  },
  faqItems: [
    { question: 'Kann ich von Oracle OPERA zu HotelStack.io migrieren?', answer: 'Ja. Unser Migrationsteam ist auf OPERA-zu-HotelStack-Umstellungen spezialisiert. Wir importieren Gaesteprofile, Reservierungshistorie, Tarifcodes, Zimmerkonfigurationen und Gruppenbloecke. Die Migration ist kostenlos und wird in der Regel innerhalb von 48-72 Stunden ohne Ausfallzeiten abgeschlossen.' },
    { question: 'Unterstuetzt HotelStack.io dieselben Integrationen wie OPERA?', answer: 'HotelStack.io verbindet sich mit ueber 100 OTAs, GDS ueber Amadeus und Sabre sowie grossen Zahlungsgateways. Unser Integrations-Marktplatz deckt dasselbe Oekosystem ab. Wir bieten zudem eine offene API fuer individuelle Integrationen.' },
    { question: 'Wie vergleicht sich HotelStack.io mit OPERA Cloud?', answer: 'OPERA Cloud ist Oracles Modernisierung ihres Legacy-Produkts. HotelStack.io wurde von Anfang an Cloud-native mit modernem Tech-Stack entwickelt. Wir bieten mehr Module (36 vs. OPERA Cloud Basis), einfachere Preisgestaltung, schnelleres Onboarding und keine Oracle-Infrastrukturabhaengigkeit.' },
    { question: 'Ist HotelStack.io fuer grosse Hotelketten geeignet, die derzeit OPERA nutzen?', answer: 'Ja. Unsere Ketten- und Enterprise-Plaene unterstuetzen Multi-Property-Verwaltung mit zentralisierten Analysen, Tarif-Distribution und Markenstandards — dieselben Funktionen, die grosse Ketten an OPERA binden, zu einem Bruchteil der Kosten.' },
  ],
};

const RMS_CLOUD_DE: ComparisonConfig = {
  slug: 'hotelstack-vs-rms-cloud',
  competitorName: 'RMS Cloud',
  heroTitle: 'HotelStack.io vs RMS Cloud',
  heroSubtitle: 'RMS Cloud bedient den APAC-Gastgewerbemarkt mit soliden PMS-Grundlagen. HotelStack.io erweitert dies mit 36 Modulen, globaler Mehrwaehrungspreisgestaltung, integriertem F&B/POS und fortschrittlichem Ertragsmanagement — alles zu einem niedrigeren Preis.',
  overviewComparison: [
    { label: 'Module gesamt', hotelstack: '36 integrierte Module', competitor: '12+ Module' },
    { label: 'Preise', hotelstack: 'Ab $49/Monat', competitor: 'Ab $80+/Monat' },
    { label: 'Globale Reichweite', hotelstack: 'Ueber 40 Laender', competitor: 'Hauptsaechlich APAC' },
    { label: 'F&B / POS', hotelstack: 'Integriert', competitor: 'Nicht verfuegbar' },
    { label: 'Ertragsmanagement', hotelstack: 'Erweitert (integriert)', competitor: 'Basis' },
    { label: 'Buchungsmaschine', hotelstack: 'BookMyRoom.io (Kostenlos)', competitor: 'Basis-Widget' },
  ],
  featureTable: [
    {
      category: 'Kern-PMS',
      features: [
        { name: 'Cloud-basiertes PMS', hotelstack: true, competitor: true },
        { name: 'Visuelle Zimmertafel', hotelstack: true, competitor: true },
        { name: 'Reservierungsverwaltung', hotelstack: true, competitor: true },
        { name: 'Nachtabschluss-Assistent', hotelstack: true, competitor: true },
        { name: 'Gruppenbuchungen', hotelstack: true, competitor: true },
        { name: 'Online Check-In Portal', hotelstack: true, competitor: 'Eingeschraenkt' },
      ],
    },
    {
      category: 'Ertrag & Distribution',
      features: [
        { name: 'Channel Manager (100+ OTAs)', hotelstack: true, competitor: 'Begrenzte OTAs' },
        { name: 'Dynamische Preisregeln', hotelstack: true, competitor: false },
        { name: 'Wettbewerbspreise-Monitor', hotelstack: true, competitor: false },
        { name: 'Was-Waere-Wenn-Ertragssimulator', hotelstack: true, competitor: false },
        { name: 'Nachfrageprognose', hotelstack: true, competitor: 'Basis' },
        { name: 'RevPAR-Analysen', hotelstack: true, competitor: 'Basis' },
      ],
    },
    {
      category: 'Gaesteverwaltung',
      features: [
        { name: '360-Grad-Gaesteprofile', hotelstack: true, competitor: 'Basis' },
        { name: 'Treueprogramm-Verwaltung', hotelstack: true, competitor: false },
        { name: 'Gaestekommunikation-Automatisierung', hotelstack: true, competitor: 'Eingeschraenkt' },
        { name: 'Gaeste-Ausgabenanalysen', hotelstack: true, competitor: false },
        { name: 'Ausweisupload & Verifizierung', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'F&B & Betrieb',
      features: [
        { name: 'POS-Terminal', hotelstack: true, competitor: false },
        { name: 'Zimmerservice-Modul', hotelstack: true, competitor: false },
        { name: 'Kuechenanzeigesystem', hotelstack: true, competitor: false },
        { name: 'Housekeeping-Verwaltung', hotelstack: true, competitor: true },
        { name: 'Wartungsauftraege', hotelstack: true, competitor: false },
        { name: 'Personalplanung & Gehaltsabrechnung', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Multi-Property & Compliance',
      features: [
        { name: 'Ketten-Dashboard', hotelstack: true, competitor: true },
        { name: 'Objektuebergreifende Analysen', hotelstack: true, competitor: 'Eingeschraenkt' },
        { name: 'Mehrwaehrungsabrechnung', hotelstack: true, competitor: 'AUD-Fokus' },
        { name: 'Regionale Steuerkonformitaet', hotelstack: true, competitor: 'Nur APAC' },
        { name: 'DSGVO-Datenschutz', hotelstack: true, competitor: 'Eingeschraenkt' },
      ],
    },
    {
      category: 'Resilienz & Offline',
      features: [
        { name: 'Offlinefaehige PWA', hotelstack: true, competitor: false },
        { name: 'Offline-Warteschlange fuer Aenderungen', hotelstack: true, competitor: false },
        { name: 'Hintergrundsynchronisierung bei Wiederverbindung', hotelstack: true, competitor: false },
        { name: 'Konfliktbewusster Abgleich', hotelstack: true, competitor: false },
        { name: 'Installierbare Rezeption', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Firmenkunden & Gruppenverkauf',
      features: [
        { name: 'Firmenratenverwaltung', hotelstack: true, competitor: false },
        { name: 'Gruppenbuchung mit Zimmerlisten', hotelstack: true, competitor: 'Eingeschraenkt' },
        { name: 'Offene-Posten- & Produktionsberichte', hotelstack: true, competitor: false },
        { name: 'Restaurantreservierungen', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Personal & HR',
      features: [
        { name: 'Mitarbeiterverzeichnis & Dienstplanung', hotelstack: true, competitor: false },
        { name: 'Lohnabrechnung', hotelstack: true, competitor: false },
        { name: 'Urlaub & Anwesenheit', hotelstack: true, competitor: false },
        { name: 'Leistungsanalysen', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$80+',
    hotelstackNote: 'Alle 36 Module enthalten. Regionale Preise in EUR, GBP, AED, INR, THB. Kostenloses Onboarding und Datenmigration.',
    competitorNote: 'AUD-basierte Preise ab $80+/Monat. Zusaetzliche Gebuehren fuer Channel Manager und Premium-Funktionen. Hauptsaechlich APAC-Support.',
  },
  advantages: [
    'Fast dreimal so viele Module (36 vs. 12+) mit allen Funktionen zu einem niedrigeren Preis',
    'Globale Abdeckung in ueber 40 Laendern vs. RMS Cloud-Fokus auf APAC-Maerkte',
    'Vollstaendiges F&B-Modul mit POS-Terminal, Zimmerservice und Kuechenverwaltung',
    'Fortschrittliches Ertragsmanagement mit dynamischer Preisgestaltung, Prognose und Simulatoren',
    'Staerkere Kanalanbindung mit 100+ OTAs und GDS ueber Amadeus und Sabre',
    'Personalverwaltung mit Planung, Gehaltsabrechnung, Anwesenheit und Leistungsverfolgung',
    'Mehrwaehrungsabrechnung in 6 Waehrungen vs. hauptsaechlich AUD-basierte Preisgestaltung',
    'Kostenloses Onboarding und Datenmigration mit 24/7 dediziertem Support',
  ],
  verdict: {
    title: 'Unser Fazit',
    summary: 'RMS Cloud ist ein leistungsfaehiges PMS fuer APAC-Objekte mit soliden Grundlagen fuer die Unterkunftsverwaltung. HotelStack.io bietet eine umfassendere Loesung mit 36 Modulen, globaler Reichweite, fortschrittlichem Ertragsmanagement und vollstaendigen F&B/POS-Funktionen — alles zu einem niedrigeren Preis. Fuer Objekte, die ueber grundlegendes PMS hinaus ein vollstaendiges Hotelbetriebsmanagement suchen, ist HotelStack.io die staerkere Wahl.',
    bestFor: [
      'Hotels, die eine vollstaendige All-in-One-Plattform jenseits des grundlegenden PMS wuenschen',
      'Objekte, die integriertes F&B, POS und Kuechenmanagement benoetigen',
      'Hotels, die ueber APAC hinaus expandieren und globale Compliance und Distribution benoetigen',
      'Objekte, die fortschrittliches Ertragsmanagement und dynamische Preisgestaltung wuenschen',
      'Hotelketten, die zentralisierte Analysen ueber globale Objekte benoetigen',
    ],
  },
  faqItems: [
    { question: 'Kann ich von RMS Cloud zu HotelStack.io migrieren?', answer: 'Ja. Unser Migrationsteam uebernimmt den vollstaendigen Datentransfer von RMS Cloud einschliesslich Gaesteprofilen, Reservierungshistorie, Tarifkonfigurationen und Zimmer-Setups. Die Migration ist kostenlos und wird in der Regel innerhalb von 48 Stunden ohne Ausfallzeiten abgeschlossen.' },
    { question: 'Funktioniert HotelStack.io gut fuer australische und APAC-Hotels?', answer: 'Absolut. HotelStack.io unterstuetzt Mehrwaehrungsabrechnung einschliesslich AUD, regionale Steuerkonformitaet fuer APAC-Maerkte und Verbindungen zu APAC-fokussierten OTAs. Viele unserer APAC-Objekte haben von RMS Cloud wegen der zusaetzlichen Module und globalen Reichweite gewechselt.' },
    { question: 'Wie vergleichen sich die Preise von HotelStack.io mit RMS Cloud?', answer: 'HotelStack.io beginnt bei $49/Monat mit allen 36 Modulen und regionalen Preisen in 6 Waehrungen. RMS Cloud beginnt bei ca. $80+/Monat AUD mit weniger Modulen und Zusatzkosten fuer Channel-Management und Premium-Funktionen.' },
    { question: 'Unterstuetzt HotelStack.io Ferienparks und Campingplaetze wie RMS Cloud?', answer: 'HotelStack.io ist fuer alle Unterkunftsarten konzipiert, einschliesslich Hotels, Resorts, Hostels, Boutique-Objekte und Serviced Apartments. Waehrend RMS Cloud spezifische Funktionen fuer Ferienparks bietet, unterstuetzt die flexible Objektkonfiguration von HotelStack.io vielfaeltige Unterkunftsmodelle.' },
  ],
};

export const COMPARISON_DE_P2: Record<string, ComparisonConfig> = {
  'hotelstack-vs-opera': OPERA_DE,
  'hotelstack-vs-rms-cloud': RMS_CLOUD_DE,
};
